import {Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation} from '@angular/core';
import {TreeNode} from "../../models";

@Component({
  selector: 'pt-tree',
  templateUrl: 'tree.component.html',
  styleUrls: ['tree.component.scss'],
  encapsulation: ViewEncapsulation.None
})
/**
 * Tree component è un albero a 2 livelli. Non l'ho fatto generico perchè non serviva.
 */
export class TreeComponent implements OnChanges {
  @Input() nodes: TreeNode[] = [];
  @Output() changeValue = new EventEmitter<TreeNode[]>();

  public internalNodes: InternalNode[] = [];

  ngOnChanges(): void {
    this.internalNodes = this.nodes.map(n => InternalNode.fromGfmiTreeNode(n));
    this.alignInternalNode();
  }

  private alignInternalNode() {
    this.internalNodes.forEach(root => {
      root.checked = InternalNode.isAllChecked(root.children || []);
      root.indeterminate = InternalNode.isIndeterminate(root.children || []);
    })
  }

  trackById(index: number, item: TreeNode) {
    return item.uuid;
  }

  getChildren(item: TreeNode) {
    return this.nodes?.find((n) => n.uuid === item.uuid)?.children || []
  }

  selectChildren(parentNode: TreeNode, childrenNode: TreeNode) {
    childrenNode.checked = !childrenNode.checked;
    this.alignInternalNode();
    this.propagateChange();
  }

  selectRoot(node: TreeNode) {
    node.checked = !node.checked;
    node.children?.forEach(c => {
      c.checked = node.checked;
    })
    this.alignInternalNode();
    this.propagateChange();
  }

  private propagateChange() {
    const response: TreeNode[] = this.internalNodes.map(c => c.toGfmTreeNode());
    this.changeValue.emit(response);
  }
}


class InternalNode {
  public indeterminate!: boolean;
  public uuid!: string;
  public label!: string;
  public help? : string;
  public checked!: boolean;
  public children!: InternalNode[]


  constructor(indeterminate: boolean, uuid: string, label: string, checked: boolean, children: InternalNode[], help?: string) {
    this.indeterminate = indeterminate;
    this.uuid = uuid;
    this.label = label;
    this.help = help;
    this.checked = checked;
    this.children = children;
  }

  static fromGfmiTreeNode(node: TreeNode): InternalNode {
    const response = new InternalNode(
      InternalNode.isIndeterminate(node.children),
      node.uuid,
      node.label,
      node.children ? InternalNode.isAllChecked(node.children) : node.checked,
      node.children ? node.children.map( m => InternalNode.fromGfmiTreeNode(m)) : [],
      node.help
    );
    return response;
  }

  static isIndeterminate(item?: InternalNode[] | TreeNode[]): boolean {
    let findCheck = false;
    let findUnckeck = false;
    if (item) {
      item.forEach(f => {
        if (f.checked) {
          findCheck = true;
        } else {
          findUnckeck = true;
        }
      })
    }
    return findCheck && findUnckeck;
  }

  static isAllChecked(item?: InternalNode[] | TreeNode[]): boolean {
    let findCheck = false;
    let findUnckeck = false;
    if (item) {
      item.forEach(f => {
        if (f.checked) {
          findCheck = true;
        } else {
          findUnckeck = true;
        }
      })
    }
    return findCheck && !findUnckeck;
  }


  toGfmTreeNode(): TreeNode {
    const response: TreeNode = {
      uuid: this.uuid,
      label: this.label,
      help: this.help,
      checked: this.checked,
      children: this.children.map((c) => c.toGfmTreeNode()),
    }
    return response;
  }
}
